import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import {application} from "../../../constants/configs";
import actions from './actions';
import messages from './messages';
import announcement from "./announcement";
import declaration from "./declaration";
import event from "./event";
import email from './email';
import stats from './stats';
import all from "./all";
import sms from './sms';

const Notices = ({match}) => (
  <div className="dashboard-wrapper">
    <Switch>
      {application.supportV2 ?
        <Redirect exact from={`${match.url}/`} to={`${match.url}/all`}/> :
        <Redirect exact from={`${match.url}/`} to={`${match.url}/actions`}/>
      }
      <Route path={`${match.url}/all`} component={all}/>
      <Route path={`${match.url}/messages`} component={messages}/>
      <Route path={`${match.url}/announcement`} component={announcement}/>
      <Route path={`${match.url}/declaration`} component={declaration}/>
      <Route path={`${match.url}/event`} component={event}/>
      <Route path={`${match.url}/groupSMS`} component={sms}/>
      <Route path={`${match.url}/groupEmail`} component={email}/>
      <Route path={`${match.url}/actions`} component={actions}/>
      <Route path={`${match.url}/stats`} component={stats}/>
      <Redirect to="/error"/>
    </Switch>
  </div>
);
export default Notices;
